

import { useContext, useEffect, useState } from 'react'
import { CURRENT_URL } from '../../config/runtimeConfig';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
// import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls';
// import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FilterMonthInput from '../../components/filterMonthInput/FilterMonthInput';
import { InvoiceContext } from '../../context/invoiceContext/InvoiceContext';
import { useNavigate, useParams } from 'react-router-dom';
import { createInvoice, detailInvoice, loadInvoice } from '../../context/invoiceContext/apiCalls';
import TableComponent from '../../components/tableComponent/TableComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { currentStatusEnvois, typeEnvois, wilayas, withTVAs } from '../../data';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import InvoiceFormat from '../../components/invoiceFormat/InvoiceFormat';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import InvoiceEndFormat from '../../components/invoiceEndFormat/InvoiceEndFormat';
import FormRadio from '../../components/formRadio/FormRadio';
import * as XLSX from 'xlsx';

function DetailInvoice() {
    const { dispatch, isFetchingEnvoisRamassageDepot, errorEnvoisRamassageDepot, invoice, envois, count: pages, countGlobal, historiesRamassage, historiesDepot, envoisDownload, settings } = useContext(InvoiceContext);

    const [addEntreprise, setAddEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [addDateApplyInvoice, setAddDateApplyInvoice] = useState("");
    const [withTVA, setWithTVA] = useState(withTVAs[0])
    const [addErrorBox, setAddErrorBox] = useState("");

    const [historiesRamassageAlt, setHistoriesRamassageAlt] = useState([]);
    const [historiesDepotAlt, setHistoriesDepotAlt] = useState([])

    const { page = 1, id } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [slicesInvoice, setSlicesInvoice] = useState([]);
    const [pagesSliceInvoice, setPagesSliceInvoice] = useState(0);
    const [activeInvoice, setActiveInvoice] = useState(false);

    useEffect(() => {
        detailInvoice(dispatch, pageSize, page, id,);
    }, [dispatch, pageSize, page, id])

    useEffect(() => {
        if (errorEnvoisRamassageDepot != false) {
            setAddErrorBox(errorEnvoisRamassageDepot);
        }
    }, [errorEnvoisRamassageDepot])

    useEffect(() => {
        if (Object.keys(invoice).length !== 0) {
            setAddEntreprise({ nom: invoice.Entreprise.nom, id: invoice.Entreprise.id, });
            setAddDateApplyInvoice(invoice.invoiceMonth)
            setWithTVA(withTVAs.filter(item => item.id === invoice.typeTVA) ? withTVAs.filter(item => item.id === invoice.typeTVA)[0] : withTVAs[0])
        }
    }, [invoice])

    useEffect(() => {
        if (!isFetchingEnvoisRamassageDepot && errorEnvoisRamassageDepot === false) {
            setHistoriesRamassageAlt([]);
            setHistoriesDepotAlt([]);

            // to eliminate duplicate ActionId in Ramassage
            var actionIdRamassage = 0;
            if (historiesRamassage.length !== 0) {
                historiesRamassage.map(item => {
                    if (item.ActionId !== actionIdRamassage) {
                        actionIdRamassage = item.ActionId;
                        setHistoriesRamassageAlt(prev => [...prev, item]);
                    }
                });
            }

            // to eliminate duplicate ActionId in Depot
            var actionIdDepot = 0;
            if (historiesDepot.length !== 0) {
                historiesDepot.map(item => {
                    if (item.ActionId !== actionIdDepot) {
                        actionIdDepot = item.ActionId;
                        setHistoriesDepotAlt(prev => [...prev, item]);
                    }
                });
            }
        }
    }, [envois, historiesRamassage, historiesDepot])



    /**************** To downlaod PDF ****************/
    useEffect(() => {
        var invoiceTuples = envoisDownload.concat(historiesRamassageAlt, historiesDepotAlt)
        let range = Math.floor(invoiceTuples.length / 46);
        if (invoiceTuples.length % 46 !== 0) {
            range++;
        }
        let rows = [];
        for (let i = 0; i < range; i++) {
            if (i + 1 == range) {
                rows.push(invoiceTuples.slice(i * 46));
            } else {
                rows.push(invoiceTuples.slice(i * 46, (i + 1) * 46));
            }
        }
        setPagesSliceInvoice(range);
        setSlicesInvoice(rows);
    }, [envoisDownload, historiesRamassageAlt, historiesDepotAlt])
    console.log(envoisDownload)

    const handleDownloadPdf = async () => {
        setActiveInvoice(true);
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: 'px',
            format: "a4"
        });
        for (let i = 0; i < pagesSliceInvoice; i++) {
            const canvas = await html2canvas(document.querySelector(`#invoice-${i}`), { scale: 3 });
            const bordData = canvas.toDataURL('image/png');

            const imgProperties = pdf.getImageProperties(bordData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

            if (i !== 0) {
                pdf.addPage();
            }
            pdf.addImage(bordData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        }

        // The last page
        const canvas = await html2canvas(document.querySelector(`#invoice-${99}`), { scale: 3 });
        const bordData = canvas.toDataURL('image/png');

        const imgProperties = pdf.getImageProperties(bordData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

        pdf.addPage();
        pdf.addImage(bordData, 'PNG', 0, 0, pdfWidth, pdfHeight);


        pdf.save('Facture_Diardzair_novembre 2024.pdf');
        setActiveInvoice(false);
    }

    const exportToExcel = () => {
        // -> npm install xlsx --legacy-peer-deps
        let envoie_excel = envoisDownload.map(item => ({
            "Date Création" : `${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}`,
            "Tracking" : item.tracking,
            "Wilaya Départ" : wilayas.filter(ele => ele.id == item.wilayaDeparture)[0] ? wilayas.filter(ele => ele.id == item.wilayaDeparture)[0]['nom'] : "n",
            "Wilaya d'Arrivé" : wilayas.filter(ele => ele.id == item.wilayaArrived)[0] ? wilayas.filter(ele => ele.id == item.wilayaArrived)[0]['nom'] : "i",
            "Designation" : item.description,
            "Prix à Ramasser" : Number.parseFloat(item.montant).toFixed(2),
            "Assurance" : item.insurance,
            "Taxe d'assurance" : 0.00,
            "Frais Livraison" : Number.parseFloat(item.cost).toFixed(2),
            "TVA(19%)" : Number.parseFloat(item.cost * 0.19).toFixed(2),
            "Net Client" : Number.parseFloat(item.montant - item.cost * 1.19).toFixed(2),
        }))
        let history_ramassage_excel = historiesRamassageAlt.map(item => ({
            "Date Création" : `${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}`,
            "Tracking" : "",
            "Wilaya Départ" : "",
            "Wilaya d'Arrivé" : "",
            "Designation" : "",
            "Prix à Ramasser" : "",
            "Assurance" : "",
            "Taxe d'assurance" : "",
            "Frais Livraison" : Number.parseFloat(item.cost).toFixed(2),
            "TVA(19%)" : Number.parseFloat(item.cost * 0.19).toFixed(2),
            "Net Client" : Number.parseFloat(0 - item.cost * 1.19).toFixed(2),
        }))
        let history_depot_excel = historiesDepotAlt.map(item => ({
            "Date Création" : `${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}`,
            "Tracking" : "",
            "Wilaya Départ" : "",
            "Wilaya d'Arrivé" : "",
            "Designation" : "",
            "Prix à Ramasser" : "",
            "Assurance" : "",
            "Taxe d'assurance" : "",
            "Frais Livraison" : Number.parseFloat(item.cost).toFixed(2),
            "TVA(19%)" : Number.parseFloat(item.cost * 0.19).toFixed(2),
            "Net Client" : Number.parseFloat(0 - item.cost * 1.19).toFixed(2),
        }))
        var result_excel = envoie_excel.concat(history_ramassage_excel, history_depot_excel)

        const worksheet = XLSX.utils.json_to_sheet(result_excel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "exportation_paiement.xlsx");
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="invoice" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Détail Facture :</span>
                </div>

                {
                    errorEnvoisRamassageDepot ? <div className='box-error'>{errorEnvoisRamassageDepot}</div> : (
                        isFetchingEnvoisRamassageDepot ? <LoadingComponent /> : (
                            <div className="content invoice">
                                <div className="box">
                                    <div className="box-content">
                                        {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                        <DropDownComponent data={[addEntreprise]} itemChoisir={addEntreprise} setItemChoisir={setAddEntreprise} filter inactive />
                                        <FilterMonthInput placeholder={"Date Application"} item={addDateApplyInvoice} setItem={setAddDateApplyInvoice} inactive />
                                    </div>
                                </div>

                                <div className="add-item">
                                    {
                                        withTVA.id === 1 && (
                                            <>
                                            <span className='color-1' onClick={handleDownloadPdf}>Télécharger PDF</span>
                                            <span className='color-1' onClick={exportToExcel}>Télécharger Excel</span>
                                            </>
                                        )
                                    }
                                </div>

                                {
                                    envois.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Frais Total</span>
                                            <TableComponent isHeaderExist={false} maxWidth={400} headers={['Id', 'Frais',]}>
                                                <>
                                                    <tr>
                                                        <td>Nombre d'Envois</td>
                                                        <td>{countGlobal}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Montant</td>
                                                        <td>{Number.parseFloat(invoice.totalEnvoisMontant).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Envois</td>
                                                        <td>{Number.parseFloat(invoice.totalEnvois).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Ramassage</td>
                                                        <td>{Number.parseFloat(invoice.totalRamassage).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total Frais Dépot</td>
                                                        <td>{Number.parseFloat(invoice.totalDepot).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total H.T</td>
                                                        <td>{Number.parseFloat(invoice.totalEnvois * 1 + invoice.totalRamassage * 1 + invoice.totalDepot * 1).toFixed(2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='inactive' style={{ width: "100%" }}><FormRadio data={withTVAs} itemChoisir={withTVA} setItemChoisir={setWithTVA} name='tab-with-without-tva' /></td>
                                                        <td></td>
                                                    </tr>
                                                    {
                                                        withTVA.id === 1 ? (
                                                            <>
                                                                <tr>
                                                                    <td>TVA (19%)</td>
                                                                    <td>{Number.parseFloat((invoice.totalEnvois * 1 + invoice.totalRamassage * 1 + invoice.totalDepot * 1) * 0.19).toFixed(2)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total a payer</td>
                                                                    <td>{Number.parseFloat(invoice.montant).toFixed(2)}</td>
                                                                </tr>
                                                            </>
                                                        ) : (
                                                            <tr>
                                                                <td>Total a payer</td>
                                                                <td>{Number.parseFloat(invoice.montant).toFixed(2)}</td>
                                                            </tr>
                                                        )
                                                    }
                                                </>
                                            </TableComponent>
                                        </div>
                                    )
                                }
                                {
                                    envois.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span> : (
                                        <div className='part'>
                                            <span className='sub-title'>Frais des Livraisons</span>
                                            <TableComponent headers={withTVA.id === 1
                                                ? ["Date d'expédition", "Envoi N°", "Type", "Destinataire", "Destination", "Pois", "Montant", "Frais", "TVA(19%)", "Rest"]
                                                : ["Date d'expédition", "Envoi N°", "Type", "Destinataire", "Destination", "Pois", "Montant", "Frais", "Rest"]}>
                                                {
                                                    envois.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{`${currentStatusEnvois.filter(item => item.id === ele.currentStatus)[0]['nom']}-${ele.tracking}`}</td>
                                                            <td>{typeEnvois.filter(item => item.id === ele.typeEnvoie)[0]['nom']} </td>
                                                            <td>{ele.nomArrived}</td>
                                                            <td>{wilayas.filter(item => item.id === ele.wilayaArrived)[0]['nom']} </td>
                                                            <td>{ele.weight}</td>
                                                            <td>{Number.parseFloat(ele.montant).toFixed(2)} </td>
                                                            <td>{Number.parseFloat(ele.cost).toFixed(2)} </td>
                                                            {
                                                                withTVA.id === 1 ? (
                                                                    <>
                                                                        <td>{Number.parseFloat(ele.cost * 0.19).toFixed(2)} </td>
                                                                        <td>{Number.parseFloat(ele.montant * 1 - ele.cost * 1.19).toFixed(2)} </td>
                                                                    </>
                                                                ) : (
                                                                    <td>{Number.parseFloat(ele.montant * 1 - ele.cost * 1).toFixed(2)} </td>
                                                                )
                                                            }
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                            {
                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item={`invoices/${id}/detail`} />)
                                            }
                                        </div>
                                    )
                                }
                                {
                                    historiesRamassageAlt.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Coût de Ramassage</span>
                                            <TableComponent maxWidth={300} headers={['Date', 'Frais']}>
                                                {
                                                    historiesRamassageAlt.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{ele.cost}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                        </div>
                                    )
                                }
                                {
                                    historiesDepotAlt.length !== 0 && (
                                        <div className='part'>
                                            <span className='sub-title'>Coût de Dépot Domicile</span>
                                            <TableComponent maxWidth={300} headers={['Id', 'Frais']}>
                                                {
                                                    historiesDepotAlt.map((ele, index) => (
                                                        <tr key={index}>
                                                            <td>{ele.createdAt.slice(0, 10)}</td>
                                                            <td>{ele.cost}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </TableComponent>
                                        </div>
                                    )
                                }

                            </div>
                        )
                    )
                }

            </div>

            <div className={activeInvoice ? 'wrapper-bord active' : 'wrapper-bord'}>
                <div className='content'>
                    <img src={`${CURRENT_URL}//nweblack.png`} />
                    <span className="loader"></span>
                </div>
            </div>
            <div style={{ opacity: "0", position: 'fixed', pointerEvents: 'none' }}>
                {
                    (!isFetchingEnvoisRamassageDepot) && (envoisDownload.length !== 0) && (
                        <>
                            {
                                [...Array(pagesSliceInvoice).keys()].map((pn, index) => (
                                    <InvoiceFormat key={index}
                                        pages={pagesSliceInvoice} page={pn} lengthEnvois={countGlobal} ArraySlice={slicesInvoice[pn]} invoice={invoice} settings={settings}
                                    />
                                ))
                            }
                            <InvoiceEndFormat lengthEnvois={countGlobal} invoice={invoice} settings={settings} />
                        </>
                    )
                }
            </div>


        </div>
    )
}

export default DetailInvoice
